import React from "react"

function ReactIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 48 48"
    >
      <path
        fill="#4E7AB5"
        d="M24 34.68C10.318 34.68 0 30.204 0 24s10.318-10.8 24-10.8S48 17.796 48 24c0 6.204-10.318 10.68-24 10.68zm0-17.962c-11.675 0-20.55 3.92-20.55 7.358 0 3.438 8.875 7.206 20.55 7.206s20.55-3.92 20.55-7.358c0-3.438-8.875-7.206-20.55-7.206z"
      ></path>
      <path
        fill="#4E7AB5"
        d="M14.882 45.6c-1.117 0-2.137-.26-3.033-.77-1.464-.837-2.514-2.314-3.039-4.275-1.375-5.138.844-13.778 5.656-22.013C20.112 8.888 27.608 2.404 33.119 2.404c1.116 0 2.136.259 3.032.77 1.462.834 2.513 2.31 3.037 4.27 1.377 5.138-.843 13.78-5.658 22.014C27.89 39.113 20.394 45.6 14.882 45.6zM33.12 6.004c-3.466 0-10.091 5.031-15.545 14.355-4.948 8.467-6.398 15.491-5.285 19.265.301 1.019.726 1.726 1.345 2.078 2.834 1.618 10.571-3.42 16.79-14.06 4.95-8.468 6.552-15.342 5.287-19.266-.325-1.01-.725-1.722-1.343-2.074-.352-.201-.76-.298-1.25-.298z"
      ></path>
      <path
        fill="#4E7AB5"
        d="M33.119 45.596c-5.517 0-13.012-6.486-18.653-16.138-4.812-8.235-7.03-16.876-5.656-22.013.525-1.961 1.575-3.438 3.038-4.273.897-.513 1.917-.772 3.032-.772 5.514 0 13.008 6.487 18.65 16.142 4.814 8.234 7.032 16.875 5.657 22.014-.525 1.96-1.575 3.436-3.036 4.27-.896.511-1.917.77-3.032.77zM14.88 6c-.488 0-.896.098-1.248.298-.618.352-1.049 1.057-1.344 2.078-1.114 3.85.337 10.799 5.285 19.266 5.449 9.323 12.075 14.354 15.545 14.354.49 0 .897-.098 1.249-.298.617-.35 1.06-1.052 1.341-2.074 1.04-3.775-.337-10.8-5.286-19.266C24.973 11.033 18.348 6 14.88 6z"
      ></path>
      <path
        fill="#8BB7F0"
        d="M28.2 24c0 2.322-1.878 4.2-4.2 4.2a4.197 4.197 0 01-4.2-4.2c0-2.322 1.878-4.2 4.2-4.2s4.2 1.878 4.2 4.2z"
      ></path>
      <path
        fill="#4E7AB5"
        d="M24 28.8a4.805 4.805 0 01-4.8-4.8c0-2.647 2.153-4.8 4.8-4.8s4.8 2.153 4.8 4.8-2.153 4.8-4.8 4.8zm0-8.4a3.604 3.604 0 00-3.6 3.6c0 1.985 1.615 3.6 3.6 3.6s3.6-1.615 3.6-3.6-1.615-3.6-3.6-3.6z"
      ></path>
      <path
        fill="#8BB7F0"
        d="M24 33.682c-12.785 0-22.8-4.253-22.8-9.682s10.015-9.682 22.8-9.682S46.8 18.571 46.8 24 36.785 33.682 24 33.682zm0-18.164c-11.708 0-21.6 3.885-21.6 8.482 0 4.597 9.892 8.482 21.6 8.482 11.708 0 21.6-3.884 21.6-8.482 0-4.598-9.892-8.482-21.6-8.482z"
      ></path>
      <path
        fill="#8BB7F0"
        d="M14.882 44.4c-.906 0-1.725-.206-2.44-.613-1.194-.683-2.026-1.875-2.474-3.543-1.297-4.844.875-13.125 5.532-21.097C20.855 9.996 28.1 3.604 33.12 3.604c.905 0 1.725.206 2.438.613 1.194.681 2.026 1.872 2.473 3.537 1.298 4.845-.874 13.126-5.534 21.099C27.146 38.006 19.903 44.4 14.882 44.4zM33.12 4.804c-4.541 0-11.514 6.286-16.58 14.95-4.435 7.59-6.609 15.699-5.41 20.18.361 1.348 1.003 2.293 1.91 2.811.53.301 1.149.455 1.842.455 4.542 0 11.514-6.288 16.577-14.953 4.436-7.591 6.612-15.702 5.41-20.182-.36-1.345-1.001-2.29-1.907-2.805-.53-.303-1.149-.456-1.842-.456z"
      ></path>
      <path
        fill="#8BB7F0"
        d="M33.119 44.396c-5.025 0-12.269-6.392-17.617-15.543C10.843 20.88 8.672 12.6 9.97 7.756c.446-1.668 1.278-2.86 2.474-3.543.713-.407 1.532-.613 2.436-.613 5.022 0 12.265 6.394 17.615 15.547 4.66 7.97 6.83 16.252 5.532 21.099-.445 1.666-1.277 2.857-2.471 3.537-.713.407-1.532.613-2.437.613zM14.88 4.8c-.692 0-1.313.154-1.842.455-.907.518-1.55 1.463-1.91 2.81-1.2 4.481.975 12.592 5.41 20.182 5.062 8.661 12.036 14.948 16.58 14.95.694 0 1.315-.154 1.844-.457.905-.516 1.547-1.46 1.907-2.805 1.2-4.482-.975-12.593-5.41-20.182C26.395 11.09 19.424 4.8 14.88 4.8z"
      ></path>
    </svg>
  )
}

export default ReactIcon
